import {useUpmPlant} from '@hconnect/upm'
import {UseQueryResult} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {SAMPLING_POINTS_COUNTS_QUERY_KEY} from '../../api/queries/getSamplingPointsCounts'
import {createSamplingPointCountKey} from '../../helpers/samplingPointCountKey.helper'
import {SamplingPointCounts, SamplingPointsCountsMap} from '../../types'

import {useSettingsQuery} from '@settings/modules/common/providers'
import {useUrlParam} from '@settings/modules/routing'

export function useSamplingPointsCountsQuery(): UseQueryResult<SamplingPointsCountsMap> {
  const plantCode = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({
    plantId: plantCode
  })
  const plantUpmId = upmPlant?.upmId
  const {t} = useTranslation()

  return useSettingsQuery(SAMPLING_POINTS_COUNTS_QUERY_KEY, [plantUpmId], {
    enabled: Boolean(plantUpmId),
    select: (samplingPointsCounts: SamplingPointCounts[]) => {
      if (!Array.isArray(samplingPointsCounts)) {
        return new Map<string, number>()
      }
      return new Map(
        samplingPointsCounts.map((count) => [
          createSamplingPointCountKey(
            count.limsSamplingPointCode,
            count.limsSamplingPointDescription
          ),
          count.sampleCount
        ])
      )
    },
    meta: {
      errorMessage: t('samplingPointsSettings.queries.fetchSamplingPointsCountsError')
    }
  })
}
